<template>
  <div class="feedback-address-box">
    <div class="cell-list">
      <div class="cell cell-bg consignee-cell" @click="consigneePickerHandle">
        <div class="label">
          收货方
          <span>*</span>
        </div>
        <div class="content">
          <span>{{ selectConsignee.name }}</span>
          <van-icon class="arrow" name="arrow" />
        </div>
      </div>
      <!-- 未聚焦输入框 -->
      <div v-if="!pasteAddressVal" class="cell cell-bg reset-cell">
        <van-field
          v-model="pasteAddressVal"
          @blur="confirmBtnShow = true"
          @focus="confirmBtnShow = false"
          class="address-inp"
          placeholder="粘贴地址信息，自动拆分识别"
        />
        <img class="address-inp-icon" src="../../../../assets/refund/icon_UpPicture.png" alt />
      </div>
      <!-- 聚焦输入框 -->
      <div v-else class="cell cell-bg text-cell">
        <van-field
          @focus="confirmBtnShow = false"
          @blur="confirmBtnShow = true"
          autosize
          type="textarea"
          v-model="pasteAddressVal" 
          class="textarea"
          ref="AddressTextarea" 
        />
        <!-- <textarea @focus="confirmBtnShow = false" @blur="confirmBtnShow = true" ref="AddressTextarea" v-model="pasteAddressVal" class="textarea" name id cols="30" rows="10"></textarea> -->
        <van-icon @click="pasteAddressVal = ''" class="clear-icon" name="clear" />
        <div @click="fillInAddress" class="Fill-in-btn">填入</div>
      </div>
      <div class="cell cell-bg">
        <div class="label">
          收货人姓名
          <span>*</span>
        </div>
        <div class="content">
          <van-field v-model="receiver" placeholder="请输入" />
        </div>
      </div>
      <div class="cell cell-bg">
        <div class="label">
          联系方式
          <span>*</span>
        </div>
        <div class="content">
          <van-field v-model="contactInformation" placeholder="请输入" />
        </div>
      </div>
      <!-- <div class="cell cell-bg" @click="addressPickerShow = true">
        <div class="label">
          收货地址
          <span>*</span>
        </div>
        <div class="content" :class="{'notselect': ShippingAddress === '请选择'}">
          <span class="content-span">{{ ShippingAddress }}</span>
          <van-icon class="arrow" name="arrow" />
        </div>
      </div>-->
      <van-cell
        class="address-cell"
        :value="ShippingAddress"
        @click="addressPickerShow = true"
        required
        is-link
      >
        <template #title>
          <span class="custom-title">收货地址</span>
        </template>
      </van-cell>
      <div class="cell cell-bg" style="align-items: baseline;">
        <div class="label">
          详细地址
          <span>*</span>
        </div>
        <div class="content address-content" :class="[address.length === 0 ? 'setHeight24' : '']">
          <van-field
            type="textarea"
            autosize
            v-model="address"
            class="field" placeholder="请输入"
          />
        </div>
      </div>

      <div class="static-btn" @click="onSubmit">确定</div>

    </div>

    <!-- <div v-show="confirmBtnShow" class="btn" @click="onSubmit">确定</div> -->

    <!-- 收货方弹出框 -->
    <van-popup
      class="assignPersonnelPicker-box"
      v-model="consigneePickerShow"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <div class="header">
        <span class="title">收货方</span>
        <van-icon @click="consigneePickerShow = false" size="12px" name="arrow-down" color="#A2A3A4" />
      </div>
      <div class="person-list">
        <div
          v-for="(item, index) of ConsigneeList"
          :key="index"
          class="person-item"
          @click="selectConsigneeHandle(item)"
        >
          <span class="name">{{ item.name }}</span>
          <img class="select-icon" v-if="item.id === selectConsignee.id" src="../../../../assets/refund/icon_check@2x.png" alt="">

        </div>
      </div>
    </van-popup>
    <!-- 收货地址弹出框 -->
    <van-popup
      class="assignPersonnelPicker-box"
      @close="addressPickerClose"
      v-model="addressPickerShow"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="header">
        <span class="title">收货地址</span>
        
        <van-icon @click="addressPickerShow = false" size="12px" name="arrow-down" color="#A2A3A4" />
      </div>
      <div class="tab-box">
        <div
          v-for="(item, index) in cityTabList"
          @click="addressTabClick(item, index)"
          :key="index"
          class="tab"
          :class="tabActive === item.code ? 'tab-active' : ''"
        >{{ item.shortName }}</div>
        <!-- <div class="tab-active">{{ 'yeyg' }}</div> -->
        <div v-if="cityTabList.length < 2" class="tab-active">请选择</div>
      </div>
      <div id="addressList" class="person-list" style="max-height: 310px;">
        <div
          v-for="(item, index) of tabPaneList"
          :key="index"
          class="person-item"
          @click.stop="selectArea(item)"
        >
          <span class="name">{{ item.shortName }}</span>
          <img class="select-icon" v-if="item.id === areaItem.id" src="../../../../assets/refund/icon_check@2x.png" alt="">
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
    import api from '../../../../service/modules/refund';
    import Vue from 'vue';
    import AddressParse from 'address-parse';
    import { Cell } from 'vant';
    Vue.use(Cell);

    export default {
        watch: {
            pasteAddressVal (newVal, oldVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        this.$refs.AddressTextarea.focus()
                    })
                }
            }
        },
        data () {
            return {
                selectConsignee: { name: '销售企业', id: 30 }, // 选择的收货方
                pasteAddressVal: '', // 粘贴的地址
                tabPaneList: [], // 对应tab的地区列表
                receiver: '', // 收货人
                contactInformation: '', // 联系方式
                ShippingAddress: '请选择', // 收货地址
                address: '', // 详细地址
                consigneePickerShow: false,
                addressPickerShow: false,
                ConsigneeList: [
                    { name: '销售企业', id: 30 },
                    { name: '监理中心', id: 10 }
                ], // 收货方类型:商家、监理中心
                cityTabList: [], // 已选择的的地址,tab选项
                flowId: '',
                allAreaList: [], // 所有地区列表
                areaItem: {}, // 点击选中的area
                userInfo: {},
                tabActive: '',
                confirmBtnShow: true, // true则显示底部的确认按钮，否则显示详细地址下面的那个

            };
        },
        created () {
            this.userInfo = JSON.parse(localStorage.getItem('refundUserInfo'));
            this.flowId = this.$route.query.flowId;
            this.init()
        },
        methods: {
          init() {
            const userInfo = this.userInfo
            // 如果是企业，默认选中企业，不用获取地址
            if (userInfo.roleList.includes('CompanyHandler')) {
              this.selectConsignee = { name: '销售企业', id: 30 }
            } else {
              // 如果是监理中心获取默认地址
              this.selectConsignee = { name: '监理中心', id: 10 }
              this.setAddress()
            }
              // 获取收货地址
            this.getCity();
          },
            // 智能识别填入地址
            fillInAddress () {
                try {
                    if (this.pasteAddressVal.trim()) {
                        const result = AddressParse.parse(this.pasteAddressVal);
                        if (result[0].province !== '云南省') {
                            return this.$toast('请输入云南省地址');
                        } else {
                          if (!result[0].city) {
                            return this.$toast('该市不存在');
                          }
                          if (!result[0].area) {
                            return this.$toast('无该区县');
                          }
                          this.cityTabList = [];
                          this.receiver = result[0].name;
                          this.contactInformation = result[0].mobile;
                          this.address = result[0].details;
                            // 获取州市的code
                            this.allAreaList.map(i => {
                                if (i.name === result[0].city) {
                                  this.$set(this.cityTabList, 0, i)
                                }
                            });
                            // 获取区县code
                            this.cityTabList[0].children.map(item => {
                                if (item.name === result[0].area) {
                                  this.$set(this.cityTabList, 1, item)
                                }
                            })
                          this.areaItem = this.cityTabList[1]
                          this.tabActive = this.cityTabList[1].code
                          // 获取相关的区县显示
                          this.allAreaList.map(i => {
                            if (i.code === this.cityTabList[0].code) {
                                this.tabPaneList = i.children; // 区县
                            }
                        });
                          console.log('this.cityTabList', this.cityTabList);
                          this.ShippingAddress = `${this.cityTabList[0].shortName}-${this.cityTabList[1].shortName}`;
                        }
                    }
                } catch (err) {
                  console.log('err', err);
                    this.$toast('请输入云南省地址');
                }
            },
            // 获取云南省的区县
            getCity () {
                api.getCity().then(res => {
                    if (res.ret === 0 && res.data[0].children.length > 0) {
                        if (res.data[0].children.length > 0) {
                            this.allAreaList = res.data[0].children; // 州市
                            this.areaInit();

                            this.areaItem = {
                              name: this.cityTabList[1].shortName,
                              code: this.cityTabList[1].code,
                              id: this.cityTabList[1].id
                            }
                        // 获取相关的区县显示
                        this.allAreaList.map(i => {
                          if (i.code === this.cityTabList[0].code) {
                              this.tabPaneList = i.children; // 区县
                          }
                      });
                      console.log('this.tabPaneList', this.tabPaneList);
                        }
                    }
                });
            },
            // 点击收货方
            selectConsigneeHandle (item) {
                this.selectConsignee = item;
                this.consigneePickerShow = false;
                // 如果是监理中心获取默认地址
                if (item.id === 10) {
                  this.setAddress()
                } else {
                    this.receiver = '';
                    this.contactInformation = '';
                    this.ShippingAddress = '请选择';
                    this.address = '';
                    this.cityTabList = [];
                    this.tabPaneList = this.allAreaList;

                }
            },
            setAddress() {
               api.currentUserDefaultDeliveryAddress().then(res => {
                console.log('res', res);
                  if (res.ret === 0 && res.data) {
                    this.receiver = res.data.contact;
                    this.ShippingAddress =
                        res.data.cityName + '-' + res.data.countyName;

                    let cityTabList = [];
                    cityTabList.push({
                        shortName: res.data.cityName,
                        code: res.data.cityCode
                    });
                    cityTabList.push({
                        shortName: res.data.countyName,
                        code: res.data.countyCode,
                    });
                    this.cityTabList = cityTabList;
                    this.allAreaList.map(i => {
                        if (i.code === res.data.cityCode) {
                            this.tabPaneList = i.children; // 区县
                        }
                    });

                 
                    this.tabActive = res.data.countyCode;

                    console.log(this.cityTabList, 'cityTabList')

                    this.contactInformation = res.data.tel;
                    this.address = res.data.address;
                  }
              });
            },
            // 地址tab选项点击事件
            addressTabClick (item, index) {
              this.tabActive = item.code;
              // 如果点击第一项
              if (index === 0) {
                  this.tabPaneList = this.allAreaList;
                  this.cityTabList = [];
              }

            },
            // 点击地区选择
            selectArea (item) {
              // 如果还没有选择地区，添加tab选项
              if (this.cityTabList.length === 0) {
                  this.cityTabList.push(item);
                  this.allAreaList.map(i => {
                      if (i.code === item.code) {
                          this.tabPaneList = i.children; // 区县
                      }
                  });
              } else if (this.cityTabList.length === 1) {
                  this.cityTabList.push(item);
                  this.addressPickerShow = false;
                  // this.cityTabList[0] = item;
              } else if (this.cityTabList.length === 2) {
                  this.cityTabList[1] = item;
                  this.addressPickerShow = false;
              }
              this.areaItem = item;
              this.tabActive = item.code;
              const div = document.getElementById('addressList')
              div.scrollTop = 0
            },
            // 初始化地区的显示
            areaInit () {
                try {
                    if (this.cityTabList.length === 0) {
                        this.tabPaneList = this.allAreaList;
                    } else if (this.cityTabList.length === 1) {
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            // 收货地址弹框关闭事件
            addressPickerClose () {
                let addressName = [];
                if (this.cityTabList.length > 0) {
                    this.cityTabList.map(item => {
                        addressName.push(item.shortName);
                    });
                    this.ShippingAddress = addressName.join(' - ');
                }
            },
            // 邮寄退货的相关表单验证, 返回true为通过，false不通过
            formCheckPass () {
                // 如果为邮寄退货就验证
                if (!this.receiver) {
                    return this.$toast('请输入收货人姓名');
                } else if (!this.contactInformation) {
                    return this.$toast('请输入联系方式');
                } else if (this.ShippingAddress === '请选择') {
                    return this.$toast('请选择收货地址');
                } else if (!this.cityTabList[0] || !this.cityTabList[1]) {
                    return this.$toast('请输入正确的收货地址');
                } else if (!this.address) {
                    return this.$toast('请输入详细地址');
                } else {
                    return true;
                }
            },
            // 提交
            onSubmit () {
                try {
                    if (this.formCheckPass() === true) {
                        // let serviceType
                        // this.servicePointList2.map(item => {
                        //   if (item.id === this.seleceServicePoint.code) {
                        //     serviceType = Number(item.type);
                        //   }
                        // });
                        // 邮寄退货的参数
                        const returnMailParam = {
                            deliveryObject: this.selectConsignee.id, // 收获对象
                            contact: this.receiver, // 联系人
                            contactTel: this.contactInformation, // 联系方式
                            province: '530000', // 省
                            city: this.cityTabList[0] ? this.cityTabList[0].code : '', // 市
                            county: this.cityTabList[1] ? this.cityTabList[1].code : '', // 区
                            address: this.address,
                            flowId: this.flowId
                        };
                        api.address(returnMailParam).then(res => {
                            if (res.ret === 0) {
                                this.$toast(res.msg);
                                setTimeout(() => {
                                    this.$router.back();
                                }, 1500);
                            } else {
                                this.$toast.fail(res.msg);
                            }
                        });
                        // 如果是本人处理不用传受理人名和id
                        // if (this.radio === "2") {
                        //   if (!this.assignPersonnelSelect.id) {
                        //     return this.$toast.fail("请选择指派人员");
                        //   } else {
                        //     let param = {}
                        //     if (this.addressRadio == "2") {
                        //       param = {
                        //         serviceId: this.seleceServicePoint.code,
                        //         serviceName: this.seleceServicePoint.name,
                        //         serviceType,
                        //         flowId: this.flowId,
                        //         refundType: this.selectReturnMethod.code,
                        //         context: this.txt,
                        //         ...returnMailParam
                        //       };
                        //     } else {
                        //       param = {
                        //         serviceId: this.seleceServicePoint.code,
                        //         serviceName: this.seleceServicePoint.name,
                        //         serviceType,
                        //         flowId: this.flowId,
                        //         refundType: this.selectReturnMethod.code,
                        //         context: this.txt
                        //       };
                        //     }
                        //     api.accept(param).then(res => {
                        //       if (res.ret === 0) {
                        //         this.$toast(res.msg);
                        //         setTimeout(() => {
                        //           this.$router.back();
                        //         }, 1500);
                        //       } else {
                        //         this.$toast.fail(res.msg);
                        //       }
                        //     });
                        //   }
                        // } else if (this.radio === "1") {
                        //   let param = {}
                        //   if (this.addressRadio == "2") {
                        //     param = {
                        //       serviceId: this.seleceServicePoint.code,
                        //       serviceName: this.seleceServicePoint.name,
                        //       serviceType,
                        //       flowId: this.flowId,
                        //       refundType: this.selectReturnMethod.code,
                        //       context: this.txt,
                        //       ...returnMailParam
                        //     };
                        //   } else {
                        //     param = {
                        //       serviceId: this.seleceServicePoint.code,
                        //       serviceName: this.seleceServicePoint.name,
                        //       serviceType,
                        //       flowId: this.flowId,
                        //       refundType: this.selectReturnMethod.code,
                        //       context: this.txt
                        //     };
                        //   }
                        //   api.accept(param).then(res => {
                        //     if (res.ret === 0) {
                        //       this.$toast(res.msg);
                        //       setTimeout(() => {
                        //         this.$router.back();
                        //       }, 1500);
                        //     } else {
                        //       this.$toast.fail(res.msg);
                        //     }
                        //   });
                        // }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            // 粘贴地址输入框失焦事件
            changePasteAddress () {
                // 取出字符串的地址
                // const address = this.pasteAddressVal;
                // const regex =
                //   "(?<province>[^省]+省|.+自治区)(?<city>[^自治州]+自治州|[^市]+市|[^盟]+盟|[^地区]+地区|.+区划)(?<county>[^市]+市|[^县]+县|[^旗]+旗|.+区)?(?<town>[^区]+区|.+镇)?(?<village>.*)";
                // const result = address.match(regex);
                // this.ShippingAddress = result.groups.city + "-" + result.groups.county;
                // this.address = result.groups.village;
            },
            // 打开收货方弹框
            consigneePickerHandle () {
                this.consigneePickerShow = true;
            }
        }
    };
</script>
<style lang="less" scoped>
.feedback-address-box {
  // padding-bottom: 80px;
  padding: 0 16px;
  .van-icon-arrow:before {
    font-size: 12px;
  }
  .cell-list {
    margin-bottom: 24px;
    .static-btn {
      background: #36b374;
      border-radius: 0.106667rem;
      padding: 0 0.426667rem;
      text-align: center;
      font-size: 0.426667rem;
      padding: 0.426667rem 0;
      color: white;
      margin-top: 15px;
    }
    .cell {
      padding: 5px 0;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .address-inp-icon {
        width: 16px;
        height: 16px;
        position: relative;
        right: 12px;
      }
      .address-inp {
        background-color: #F9FAFC;
        width: 100%;
        height: 44px;
        padding-right: 28px;
        padding-left: 15px;
        border-radius: 4px;
      }
      .label {
        font-size: 14px;
        color: #666666;
        span {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #F94F4E;
        }
      }
      /deep/.content {
        display: flex;
        align-items: center;
        .van-cell {
          padding-right: 0;
        }

        .van-field__control {
          text-align: right;
          color: #171A1D;
        }
        .van-radio__label {
          font-size: 14px;
          color: #171a1d;
        }
        .van-radio__icon {
          display: flex;
          align-items: center;
        }
        .content-span {
          font-size: 14px;
          color: #171a1d;
        }
        .arrow {
          font-size: 1px;
          margin-left: 5px;
        }
        span {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #171A1D;
        }
      }
      /deep/.address-content {
        flex: 1;
        margin-left: 10px;
        .van-field__control {
          // max-height: 100px;
        }
      }
      /deep/.setHeight24 {
        textarea{
          height: 24px !important;
        }
      }
      .notselect {
        color: #cccccc;
      }
    }
    .consignee-cell {
      padding: 19px 0 25px;
      margin-bottom: 25px;
    }
    /deep/.address-cell {
      padding: 15px 0;
      border-bottom: 1px solid #eeeeee;
      .custom-title {
        color: #666666;
      }
      .van-cell__right-icon {
          height: 0;
          font-size: 1px;
          line-height: inherit;
      }
      .van-cell__value {
        color: #333333;
      }
    }
    /deep/.van-cell--required::before {
      display: none;
    }
    /deep/.van-cell .custom-title::after {
      content: "*";
      color: red;
      margin-left: 4px;
    }
    .text-cell {
      position: relative;
      border-bottom: 0;
      .textarea {
        background: #f8f9fb;
        border-radius: 4px;
        padding: 12px 37px 35px 12px;
        width: 100%;
        border: none;
        line-height: 20px;
        box-sizing: border-box;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      .Fill-in-btn {
        position: absolute;
        background: #36b374;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        font-weight: 500;
        line-height: 28px;
        width: 52px;
        right: 12px;
        bottom: 12px;
      }
      .clear-icon {
        position: absolute;
        top: 13.5px;
        right: 13.5px;
        font-size: 16.5px;
        color: #cccccc;
      }
    }
    .reset-cell {
      padding-right: 0;
      background-color: #f9fbfc;
      border-bottom: 0;
      margin-bottom: 10px;
    }
  }
  .assignPersonnelPicker-box {
    padding: 0 16px;
    .header {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      position: fixed;
      background-color: white;
      width: 92vw;
      .title {
        font-size: 16px;
        color: #171a1d;
        font-weight: 600;
      }
    }
    .tab-box {
      display: flex;
      border-bottom: 1px solid #f5f6f9;
      padding-top: 11px;
      margin-top: 48px;
      .tab {
        margin-right: 21px;
        font-size: 14px;
        color: #666666;
        padding-bottom: 14.5px;
      }
      .tab-active {
        margin-right: 21px;
        font-size: 14px;
        color: #171a1d;
        padding-bottom: 14.5px;
        border-bottom: 1px solid #36b374;
      }
    }
    .person-list {
      padding-bottom: 100px;
      max-height: 350px;
      overflow: auto;
      padding-top: 40px;
      &::-webkit-scrollbar {
        display: none;
      }
      .person-item {
        padding: 20px 0;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #f5f6f9;
        .name {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 16px;
          color: #171A1D;
        }
        .select-icon {
          height: 18px;
          width: 18px;
        }
      }
    }
    .box1 {
      text-align: center;
      margin-top: 64px;
      padding-bottom: 87px;
      img {
        display: inline-block;
        width: 74px;
        height: 62px;
      }
      .tip1 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 24px;
      }
      .tip2 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 8px;
      }
    }
  }
  .btn {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background: #36b374;
    border-radius: 4px;
    color: white;
    padding: 0 16px;
    text-align: center;
    font-size: 16px;
    padding: 16px 0;
    color: white;
    width: 92%;
  }
}
</style>
